import { render, staticRenderFns } from "./eventOverview.vue?vue&type=template&id=847ddfce&scoped=true&"
import script from "./eventOverview.vue?vue&type=script&lang=ts&"
export * from "./eventOverview.vue?vue&type=script&lang=ts&"
import style0 from "./eventOverview.vue?vue&type=style&index=0&id=847ddfce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847ddfce",
  null
  
)

export default component.exports